import { cm } from '../theme.pdf';

export const SECTION_SPACING = cm(0.32);
export const BLOCK_SPACING = cm(0.14);
